import Loading from '../components/Loading';
import EpisodeResults from '../episodes/EpisodeResults';

export default function FourMinute({ loading, fourMinEpisodes }) {
  if (loading) {
    return <Loading loading={loading} />;
  } else {
    return <EpisodeResults currentEpisodes={fourMinEpisodes} />;
  }
}
